export default {
  relatedPersonDeleteIcon: 40,
  stickyPersonHeader: 20,
}
